import { render, staticRenderFns } from "./Montos.vue?vue&type=template&id=cc634972&scoped=true"
import script from "./Montos.vue?vue&type=script&lang=js"
export * from "./Montos.vue?vue&type=script&lang=js"
import style0 from "./Montos.vue?vue&type=style&index=0&id=cc634972&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc634972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc634972')) {
      api.createRecord('cc634972', component.options)
    } else {
      api.reload('cc634972', component.options)
    }
    module.hot.accept("./Montos.vue?vue&type=template&id=cc634972&scoped=true", function () {
      api.rerender('cc634972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/infoBase/Montos.vue"
export default component.exports